var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container-terms"},[_c('img',{attrs:{"src":_vm.omr.omr_link}})])}
var staticRenderFns = []

export { render, staticRenderFns }